






















































import {Component, Prop, Vue} from 'vue-property-decorator';
import StatusTag from '@/components/lib/StatusTag.vue'
import HistorySection from "@/components/HistorySection.vue";
import {Category, IHistory, IRequestExtended} from "@/entities";
import {StatusTagType, StatusTagTypeArray} from "@/components/lib/models";

@Component({
  components: {
    StatusTag,
    HistorySection
  }
})
export default class OrderItemCard extends Vue {

  @Prop() readonly category?: Category
  @Prop() readonly status?: string
  @Prop({ default: false }) readonly oneLine?: boolean
  @Prop({ default: false }) readonly showControl?: boolean
  @Prop() readonly fetchHistories?: (payload?: IRequestExtended) => Promise<IHistory[]>
  @Prop({
    default: () => ((status: string): StatusTagType => {
      return StatusTagTypeArray.map(s => s as string).indexOf(status) === -1 ? 'none' : status as StatusTagType;
    })
  }) readonly mapMethod?: (status?: string) => StatusTagType
  @Prop({ default: 'statuses.entities.order' }) readonly scope?: string

  get categoryName(): string {
    const category = this.category;
    return category ? this.$t(`category.${category}`) as string : '';
  }

  private showHistory = false;
  private calledHistory = false;

  private toggleExpanded(): void {
    this.showHistory = !this.showHistory;
    this.calledHistory = true;
  }

  get mappedStatus(): StatusTagType {
    return this.mapMethod?.(this.status) || 'none';
  }

  get statusTransPath(): string {
    return this.scope + '.';
  }

}
